import React, { Component } from "react";
import { leadType } from "../../../app";
import commonContext, { AppContext } from "../../context/common";

interface IProps {
    title?: string;
    noneText?: string;
    errorText?: string;
    options?: Array<object>;
    name?: string;
    handlerOnChange?: Function;
    value?: any;
    objectKey?: any;
    readonly?: boolean;
    postFix?: string;
}
interface IState {}
class SelectForm extends Component<IProps, IState> {
    static contextType = commonContext;
    setLead: Function;
    setLeadError: Function;
    leadError: any;
    lead: leadType;
    render() {
        this.setLead = (this.context as AppContext).setLead;
        this.setLeadError = (this.context as AppContext).setLeadError;
        this.leadError = (this.context as AppContext).leadError;
        this.lead = (this.context as AppContext).lead as leadType;
        return (
            <>
                <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 ">
                    {this.props.title}
                </label>
                {this.props.readonly ? (
                    <p className="w-full mt-1 mb-4 sm:mb-4 md:mb-6 lg:mb-6 xl:mb-6 focus:ring-gray-500 focus:border-gray-500 block w-full text-base md:text-base lg:text-lg xl:text-xl border-gray-300 border-b-2 border-gray-200">
                        {this.props.value}&nbsp;
                    </p>
                ) : (
                    <>
                        <select
                            className="appearance-none relative selectDropdown w-full mt-1 mb-4 sm:mb-4 md:mb-6 lg:mb-6 xl:mb-6 focus:ring-gray-500 focus:border-gray-500 block w-full text-base md:text-base lg:text-lg xl:text-xl border-gray-300 border-b-2 border-gray-200"
                            name={this.props.name}
                            onChange={(e) => {
                                if (e.target.value) {
                                    let select = {};
                                    select[this.props.name] = e.target.value;
                                    this.setLead(select);
                                    select[this.props.name] = "";
                                    this.setLeadError(select);
                                    return this.props.handlerOnChange
                                        ? this.props.handlerOnChange(e)
                                        : "";
                                }
                            }}
                            value={
                                this.lead[this.props.name]
                                    ? this.lead[this.props.name]
                                    : this.props.value
                            }
                        >
                            <option value="">{this.props.noneText}</option>
                            {this.props.options?.map((option, index) => (
                                <option
                                    key={index}
                                    value={option[this.props.name]}
                                >
                                    {
                                        option[
                                            this.props.objectKey
                                                ? this.props.objectKey
                                                : this.props.name
                                        ]
                                    }{" "}
                                    {this.props.postFix}
                                </option>
                            ))}
                        </select>
                        <span
                            className={
                                (!this.leadError[this.props.name]
                                    ? "hidden"
                                    : "") +
                                " error-msg text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm"
                            }
                        >
                            {this.leadError[this.props.name]}
                        </span>
                    </>
                )}
            </>
        );
    }
}

export default SelectForm;
